import { expVal } from '@atlassian/jira-feature-experiments';

const Sea3716JiraCreateViewWithRovoRelayprovider = {
	get(): boolean {
		return expVal('sea-3716_jira_create_view_with_rovo', 'isEnabled', false);
	},
};

export default Sea3716JiraCreateViewWithRovoRelayprovider;
